import Component from '../abstracts/Component';
import brightcovePlayerLoader from '@brightcove/player-loader';

/**
 Video brightcove
 */

export default class VideoBrightcove extends Component {

  static get SELECTORS() {
    return {
      videoWrapper: '.brightcove-wrapper',
      videoplayer: 'video-js',
      videoTracksControls: '.brightcove-controls-tracks'
    };
  }

  static getOpts (playerElement) {
    var data = $(playerElement).data();

    var opts = {
      aspectratio: data['aspectratio'] || '16:9',
      playerID: data['playerId'] || 'default',
      embed: data['embed'] || 'in-page',
      controls: data['controls'] || false,
      videoID: data['videoId'],
      autoStart: data['autostart'] || false,
      startOnScroll: data['startOnScroll'] || false,
      videoRepeat: data['repeat'] || false,
      playlistID: data['playlistId'],
      applicationID: data['applicationId'],
      muted: data['muted'] || false,
      poster: data['videoPoster'],
      hideVideo: data['hideVideo'],
      accountId: data['accountId'],
      width: data['width'] || '100%'
    };

    return opts;
  }

  static bindEvents() {

    if  ( $(VideoBrightcove.SELECTORS.videoplayer).length) {

      $(window).on('resize scroll', function (e) {

        $(VideoBrightcove.SELECTORS.videoplayer).each(function (i, ele) {

          let videoID = $(this).attr('id'),
            opts = VideoBrightcove.getOpts($(this).parents(VideoBrightcove.SELECTORS.videoWrapper)), // container of brightcove player
            myPlayer = bc(videoID),
            currentElement = $(ele);

          if (myPlayer !== undefined) {
            if (VideoBrightcove.isElementInViewport( currentElement )) {

              if (opts.startOnScroll) {

                myPlayer.play().then(function() {
                  myPlayer.play();
                })
                  .catch(function(error) {
                    myPlayer.muted(true);
                    myPlayer.play();
                  });
              }
            }else{
              if (! myPlayer.hasClass('vjs-waiting') ){
                myPlayer.pause();
              }
            }
          }
        });
      });
    }
  }

  static initPlayer(wrapper, ele){

    let opts = VideoBrightcove.getOpts(ele),
      currentElement = $(ele),
      eleID = '#' + currentElement.attr('id'),
      videoPoster = '';

    if (opts.poster) {
      videoPoster = opts.poster;
    }

    brightcovePlayerLoader.reset();

    //https://support.brightcove.com/brightcove-player-loader
    // https://docs.brightcove.com/brightcove-player/1.x/Player.html

    brightcovePlayerLoader({
      refNode: document.querySelector(eleID),
      refNodeInsert: 'prepend',
      accountId: opts.accountId,  //required - A Video Cloud account ID
      playerId: opts.playerID,   //required
      videoId: opts.videoID,
      embedType: opts.embed, //in-page or iframe
      applicationId: opts.applicationID, // The application ID to be applied to the generated embed.
      media: opts.media,
      embedOptions: {
        tagName: 'video-js', // video-js or video - default is video-js
        unminified: false, // for debugging: use the un-minified version of the player
        responsive: {
          aspectRatio: opts.aspectratio,
          maxWidth : opts.width
        }
      },
      options : {
        // autoplay: opts.autoStart,
        controls: opts.controls,
        loop: opts.videoRepeat,
        muted: opts.muted,
        poster: videoPoster
      },

      onEmbedCreated: function(success){
        currentElement.css({
          'padding-top': 0
        });
      },

      onSuccess: function (success) {

        let myPlayer = success.ref,
          videoID = $(myPlayer).attr('id');

        if (opts.poster) {
          videoPoster = opts.poster;
        }else{
          videoPoster = myPlayer.mediainfo.poster;
        }

        myPlayer.on('error', function (error) {
          console.info('[Video Brightcove] error general', error);
        });

        myPlayer.on('loadstart', function () {
          $('#' + videoID).css({'opacity': 0});
        });

        myPlayer.on('loadedmetadata', function () {
          $('#' + videoID).css({'opacity': 1});
          console.log('[Video Brightcove] loadedmetadata');

          if (!opts.controls) {
            myPlayer.controlBar.hide();
          }

          if (opts.autoStart) {
            let playVideo = myPlayer.play(); // Browser/platform autoplay policies - https://support.brightcove.com/autoplay-considerations

            if (playVideo !== undefined) { // check if the video played, otherwise I'll put the video on mute
              playVideo
                .then(function () {
                  myPlayer.muted(opts.muted);
                })
                .catch(function (error) {
                  myPlayer.muted(true);
                })
                .finally(function () {
                  if (VideoBrightcove.isElementInViewport(currentElement)) {
                    myPlayer.currentTime(0);
                    myPlayer.play();
                  } else {
                    myPlayer.pause();
                  }
                });
            }
          }

        });

        myPlayer.on('loadeddata', function () {
          console.log('[Video Brightcove] loadeddata');
          VideoBrightcove.bindEvents();
          VideoBrightcove.manageCaptionsButton(ele.get(0),this);
        });

        myPlayer.on('play', function () {
          VideoBrightcove.togglePlayButtonMobile(this);
        });


        myPlayer.on('pause', function () {
          VideoBrightcove.togglePlayButtonMobile(this,false);
        });

        myPlayer.on('ended', function () {

          if (opts.hideVideo){
            currentElement.css({
              'background-image' :'url(' + currentElement.data('videoPoster') + ')'
            });

            myPlayer.hide();
            VideoBrightcove.togglePlayButtonMobile(this,false, true);

          }else{
            myPlayer.currentTime(0);

            let playerID = $(ele).attr('id');
            if ($('div').data('PlayerID', playerID)) {
              $('div').data('PlayerID', playerID).removeClass('pause-button');
            }
          }
        });

      },

      onFailure: function (error) {
        console.info('[Video Brightocove] Loading faild', error);
      }
    });

  }

  static togglePlayButtonMobile(ele, playVideo = true, removeVideo = false){

    let playerID = $(ele).attr('data-video-id'),
      videoJsId = '.brightcove-controls[data-player-id="player-' + playerID + '"]';

    if (removeVideo){
      $(videoJsId).remove();
      return;
    }

    if (playVideo) {
      $(videoJsId).addClass('pause-button');
    }else{
      $(videoJsId).removeClass('pause-button');
    }
  }

  static isElementInViewport(el) {

    var pp = $(el).offset();
    var top = pp.top;
    var left = pp.left;
    var width = el.outerWidth();
    var height = el.outerHeight(true);

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }

  setup(){

    console.info("[Video Brightcove] setup");

    $(VideoBrightcove.SELECTORS.videoWrapper).each(function (i) {

      let wrapper = $(this);

      if (wrapper.data('asyncSrc')) {
        window.load = VideoBrightcove.initPlayer(i, wrapper);
      }else{
        VideoBrightcove.initPlayer(i, wrapper);
      }
    });
  }

  init() {
    // BrightCove: https://github.com/brightcove/player-loader

    console.info("[Video Brightcove] init");
    this.setup();

    VideoBrightcove.triggerPlayButtonMobile();
  }

  static triggerPlayButtonMobile(){

    $('.brightcove-controls').on('click', function(){
      let playerID = $(this).data('playerId'),
        videoJsId = $('#' + playerID).find('video-js').attr('id'),
        myPlayer = window.bc(videoJsId);

      if ( $(this).hasClass('pause-button') ){
        myPlayer.pause();
      } else{
        myPlayer.play();
        $(this).addClass('pause-button')
      }

    });
  }

  static manageCaptionsButton(elem,obj) {
    // captions part
    let lang="en";
    let captionsControl = elem.querySelector(VideoBrightcove.SELECTORS.videoTracksControls);
    let captionsIconOff = captionsControl.querySelector('.icon-captions-off');
    let captionsIconOn = captionsControl.querySelector('.icon-captions-on');
    let areCaptionsEnabled = false; // Initial state
    let captionsTrack = VideoBrightcove.findCaptionsTrack(obj.mediainfo.textTracks);
    // enable the button
    if (captionsTrack === null) {
      console.error('No captions or subtitles track found!');
      return;
    } else {
      // showing button
      captionsControl.classList.remove('d-none')
    }
    // bind click on controls
    captionsControl.addEventListener('click', () => {
      areCaptionsEnabled = !areCaptionsEnabled;
      if (areCaptionsEnabled) {
        captionsIconOff.style.display = 'none';
        captionsIconOn.style.display = 'block';
        // Open the English version captions
        for (var i = 0; i < (obj.textTracks().length); i++) {
          if (obj.textTracks()[i].language === lang) {
            obj.textTracks()[i].mode = "showing";
          }
        }
      } else {
        captionsIconOff.style.display = 'block';
        captionsIconOn.style.display = 'none';
        // close the English version captions
        for (var i = 0; i < (obj.textTracks().length); i++) {
          if (obj.textTracks()[i].language === lang) {
            obj.textTracks()[i].mode = "hidden";
          }
        }
      }
    });
  }
  static findCaptionsTrack(textTracks) {
    for (let i = 0; i < textTracks.length; i++) {
      if (textTracks[i].kind === 'captions' || textTracks[i].kind === 'subtitles') {
        return textTracks[i];
      }
    }
    return null; // No suitable track found
  }

  render() {
    super.render();
    this.init();
  }
}
